module.exports = __webpack_public_path__ + "static/media/nz.3241e927.svg";